import React from "react";
import Image from "../../elements/Image";
import Icon9 from "../../../assets/images/icon5.svg";
import Icon10 from "../../../assets/images/icon6.svg";
import Icon11 from "../../../assets/images/icon7.svg";
import Icon12 from "../../../assets/images/icon8.svg";

const careerDataOne = [
  { title: "Community Manager", role: "Accountant", location: "San Francisco, CA", type: "Full Time" },
  { title: "Product Designer", role: "Designer", location: "New York, NY", type: "Part Time" },
  { title: "Software Engineer", role: "Developer", location: "Austin, TX", type: "Full Time" },
  { title: "Software Engineer", role: "Developer", location: "Austin, TX", type: "Full Time" },
];

const careerDataTwo = [
  { title: "Marketing Lead", role: "Strategist", location: "Chicago, IL", type: "Full Time" },
  { title: "HR Manager", role: "Recruiter", location: "Los Angeles, CA", type: "Part Time" },
  { title: "UI/UX Designer", role: "Designer", location: "Boston, MA", type: "Full Time" },
  { title: "UI/UX Designer", role: "Designer", location: "Boston, MA", type: "Full Time" },
];

const CareerCards = () => {
  const renderCards = (data) =>
    data.map((card, index) => (
      <div key={index} className="relative px-12 py-10 bg-shades-02 rounded-lg min-w-[250px] flex-shrink-0">
        <div className="relative flex items-center gap-4 mb-8">
          <Image src={Icon9} width={40} height={40} alt="" classes="!w-10 !h-10 overflow-hidden" />
          <h3 className="text-2xl font-medium text-white">{card.title}</h3>
        </div>
        <div className="relative flex items-center flex-wrap gap-2">
          <div className="relative py-3 px-4 rounded-md bg-shades-03 flex items-center gap-2">
            <Image src={Icon10} width={20} height={20} alt="Icon" classes="!w-5 !h-5 text-white" />
            <div className="text-sm capitalize text-white">{card.role}</div>
          </div>
          <div className="relative py-3 px-4 rounded-md bg-shades-03 flex items-center gap-2">
            <Image src={Icon11} width={20} height={20} alt="Icon" classes="!w-5 !h-5 text-white" />
            <div className="text-sm capitalize text-white">{card.location}</div>
          </div>
          <div className="relative py-3 px-4 rounded-md bg-shades-03 flex items-center gap-2">
            <Image src={Icon12} width={20} height={20} alt="Icon" classes="!w-5 !h-5 text-white" />
            <div className="text-sm capitalize text-white">{card.type}</div>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="flex flex-col gap-5 overflow-hidden">

      <div className="overflow-hidden">
        <div className="flex animate-scroll-right gap-5">
          {renderCards(careerDataOne)}
          {renderCards(careerDataOne)}
        </div>
      </div>
      <div className="overflow-hidden">
        <div className="flex animate-scroll-left gap-5">
          {renderCards(careerDataTwo)}
          {renderCards(careerDataTwo)}
        </div>
      </div>

    </div>
  );
};

export default CareerCards;
